import React from 'react';
import { useTranslation } from 'react-i18next';
import { Gamepad2, Grid3X3, Headphones, Monitor } from 'lucide-react';

const Excellence = () => {
  const { t } = useTranslation();

  const stats = [
    { icon: Gamepad2, label: t('excellence.stats.games') },
    { icon: Grid3X3, label: t('excellence.stats.genres') },
    { icon: Headphones, label: t('excellence.stats.support') },
    { icon: Monitor, label: t('excellence.stats.crossPlatform') }
  ];

  return (
    <section className="py-20 md:py-32 relative overflow-hidden">
      {/* Background glow */}
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-red-500/10 rounded-full blur-[150px]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="font-display text-3xl md:text-5xl font-bold mb-4">
            <span className="gaming-gradient-text">{t('excellence.title')}</span>
          </h2>
          <p className="text-lg text-white/60 max-w-2xl mx-auto">
            {t('excellence.subtitle')}
          </p>
        </div>

        {/* Stats grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((stat, index) => (
            <div 
              key={index}
              className="stat-card p-6 rounded-2xl text-center transition-all duration-300 hover:border-red-500/50"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-xl gaming-gradient flex items-center justify-center">
                <stat.icon className="w-7 h-7 text-white" />
              </div>
              <p className="font-semibold text-white/90">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Excellence;
